module.exports = __webpack_public_path__ + "img/哇.72ba2ac1.png";